import { Routes, Route } from 'react-router-dom';

import routes from '../config/routesConfig';

import ProtectedRoutes from './ProtectedRoutes';
import { ROUTE_TYPES } from '../config/constants';
import { renderRoutes } from '../helpers';

const RemoteRoutes = () => (
  <Routes>
    {renderRoutes(routes, ROUTE_TYPES.publicRoutes)}
    <Route path="*" element={<ProtectedRoutes />} />
  </Routes>
);

export default RemoteRoutes;
